import React from 'react';
import {useSelector, shallowEqual} from 'react-redux';

import AccessDenied from '../Elements/AccessDenied';
import utilities from '../../utilities/utilities';

const checkUserAccess = (WrappedComponent, options = {}) => {
  const ComponentWrapper = (props) => {
    // Get redux states.
    const {userData, userDataFetched} = useSelector(state => ({
      userData: state.user.userData,
      userDataFetched: state.user.userDataFetched,
    }), shallowEqual);
    if (userDataFetched && !utilities.isLoggedIn(userData)) {
      return <AccessDenied {...options} />;
    }
    return <WrappedComponent {...props} />;
  };
  return ComponentWrapper;
};

export default checkUserAccess;
